import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/auth',
    component: () => import('@/components/layout/AuthWrapper.vue'),
    meta: {
      layout: 'fullWidth',
      requiresAuth: false //加入requiresAuth，只有auth以下的路由不需要判斷是否需要認證
    },
    children: [
      {
        path: '',
        redirect: 'login'
      },
      {
        name: 'Login',
        path: 'login',
        component: () => import('@/views/Login.vue'),
        meta: {
          layout: 'fullWidth',
          requiresAuth: false
        }
      }
    ]
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: "/insurancedatas",
    name: "insurancedata-list",
    component: () => import('../views/insurancedatas/InsuranceDataList')
  },
  {
    path: "/insurancedatas/:id",
    name: "insurancedata-detail",
    component: () => import('../views/insurancedatas/InsuranceData')
  },
  {
    path: "/addinsurancedata",
    name: "add-insurancedata",
    component: () => import('../views/insurancedatas/AddInsuranceData')
  },
  {
    path: "/sexandcompanysummarychart",
    name: "sexandcompanysummarychart",
    component: () => import('../views/charts/SexAndCompanySummaryChart')
  },
  {
    path: "/holders",
    name: "holder-list",
    component: () => import('../views/holders/HolderList')
  },
  {
    path: "/holders/:id",
    name: "holder-detail",
    component: () => import('../views/holders/Holder')
  },
  {
    path: '/productanalysischart',
    name: 'productanalysischart',
    component: () => import('../views/charts/ProductAnalysisChart')
  },
  {
    path: '/salesanalysischart',
    name: 'salesanalysischart',
    component: () => import('../views/charts/SalesAnalysisChart')
  },
  {
    path: '/insurancecompany',
    name: 'insurancecompany',
    component: () => import('../views/insurancecompanies/InsuranceCompany')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('../views/insurancedatas/TestInsuranceForm')
  },
  {
    path: '/salesmananalysischart',
    name: 'salesmananalysischart',
    component: () => import('../views/charts/SalesmanAnalysisChart')
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/users/User')
  },
  {
    path: '/holdersmses',
    name: 'holdersmses',
    component: () => import('../views/holdersmsmessages/NewMessage')
  },
  {
    path: '/holdersmses-list',
    name: 'holdersmses-list',
    component: () => import('../views/holdersmsmessages/SentList')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//To/From相同就不用重新導向
function checkIsTheSameDestination (from, to, next) {
  if ((from.fullPath !== to.fullPath) || (from.name !== to.name)) {
    next()
  }
}

router.beforeEach(async(to, from , next) =>{
  //檢查目的路由有沒有在meta設置requireAuth: false
  if (to.matched.some(
        record => !Object.keys(record.meta).includes('requiresAuth'))
        ){
    //auth變成模組後，store.getters.checkTokenExists改寫
    const token = await store.dispatch('auth/checkTokenExists');
    if (token == ''){
      if (from.path !== '/auth/login'){
        next({
          path: '/auth/login',
          query: {
            redirect: to.fullPath
          }
        });
      }
    }
    checkIsTheSameDestination(from, to, next);
  } else {
    checkIsTheSameDestination(from, to, next);
  }
})
export default router
